import { selectItemsContext, viewSelectItems } from "#/admin/legacy/assessment-builder/assessment-select-items.js";
import "#vendor/humps.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.Base = class Base extends Backbone.View {
  constructor() {
    super(...arguments);
    this.handleAttributeChange = this.handleAttributeChange.bind(this);
  }

  initialize(options) {
    this.selectItems = viewSelectItems(options);
  }

  selectTemplateContext(attributes, itemNames) {
    return selectItemsContext(attributes, this.selectItems, itemNames);
  }

  handleAttributeChange(event) {
    let value;
    const input = event.target;
    const name = humps.camelize(input.getAttribute("name"));

    if (input.matches('input[type="checkbox"]')) {
      value = input.checked;
    } else {
      value = input.value;

      if (input.localName === "sp-select" && value == null) {
        value = "";
        input.value = value;
      }
    }

    return this.model.set(name, value);
  }
};
